import { Component, Input } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-paragraph-loader',
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './paragraph-loader.html',
  styleUrl: './paragraph-loader.scss',
  standalone: true,
})
export class ParagraphLoader {
  @Input() isReduced!: boolean;
}
